import { Component, element as $, loggerService, services } from '@contorion/core';
import { IWhfService } from '../interfaces/whf-service.interface';

const SELECTOR_FORM: string = '.weltherrschaftsformel';

export class WhfComponent extends Component {
    protected whfService: IWhfService;

    protected get form(): HTMLFormElement {
        return <HTMLFormElement> $(SELECTOR_FORM, this.element);
    }

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected async init(): Promise<void> {
        await this.loadServices();
        this.bindEvents();
    }

    protected async loadServices(): Promise<void> {
        this.whfService = <IWhfService> await services.get('whf-service');
    }

    protected bindEvents(): void {
        this.form && this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    protected applyForm(): void {
        const query: any = {};

        for (const element of Array.apply(null, this.form.elements)) {
            if (typeof element.name === 'undefined' || element.name.length === 0) {
                continue;
            }

            query[element.name] = element.value;
        }

        this.whfService.apply(query);
    }

    protected onFormSubmit(e: Event): void {
        e.preventDefault();

        this.applyForm();
    }
}
